"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PanelStyled = require("./Panel-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Panel = function Panel(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(_PanelStyled.StyledPanel, other, children);
};

Panel.propTypes = {
  /** Content of the Panel. */
  children: _propTypes.default.node,

  /** Hide the border of the Panel. */
  noBorder: _propTypes.default.bool,

  /** Remove the padding from the Panel. */
  noPadding: _propTypes.default.bool,

  /** Dark style Panel. */
  dark: _propTypes.default.bool,

  /** Black style Panel. */
  black: _propTypes.default.bool,

  /** White style Panel. */
  white: _propTypes.default.bool,

  /** Light Blue style Panel. */
  lightBlue: _propTypes.default.bool,

  /** Blue style Panel. */
  blue: _propTypes.default.bool,

  /** Dark Blue style Panel. */
  darkBlue: _propTypes.default.bool
};
Panel.defaultProps = {};
Panel.displayName = 'Panel';
var _default = Panel;
exports.default = _default;